// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { abilitiesPlugin } from '@casl/vue';
import { register } from 'register-service-worker'

Vue.config.devtools = true;

import App from './App';
import {
  ability,
  store
} from './store';
import i18n from './lang';
import loading from './shared/loading';
import VueColumnsResizable from './shared/plugins/vue-columns-resizable';
import router from './router';
import debug from './shared/debug';

Vue.prototype.$debug = debug;
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(loading);
Vue.use(abilitiesPlugin, ability);
Vue.use(VueColumnsResizable);

console.log("process.env", process.env);

if (process.env.NODE_ENV != 'production') {
  store.dispatch("global/setLanguage", "ro");
}

const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: {
    App
  }
});

if (process.env.NODE_ENV != 'production') {
  window._app = app;
  window._store = store;
  window._router = router;
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.')
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      console.log('New content is available; please refresh.');
      /*
      try {
        app.$bvToast.toast(app.$t("New content is available; please refresh page."), {
          title: app.$t("Success"),
          variant: "success",
          toaster: "b-toaster-bottom-right",
          solid: true
        });
      } catch (err) {
        //noop
      }
      */
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
